module.exports = __webpack_public_path__ + "assets/img/prd3-10.5d9537d8.jpg";